import React from "react";
import { withRouter } from "./withRouter";

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.router.location.pathname !== prevProps.router.location.pathname
    ) {
      window.scrollTo(0, 0);
    }
  }
  render() {
    return null;
  }
}

export default withRouter(ScrollToTop);
